import { render, staticRenderFns } from "./IconTransfer.vue?vue&type=template&id=bc323d9e&"
import script from "./IconTransfer.vue?vue&type=script&lang=js&"
export * from "./IconTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports